import React from "react";
import "./HeroPostLaunch.css";
import {TranslationsMap} from "../../pages/CountryPage/CountryPage";
import logoMobile from "../../assets/logo/horizontal-small-white.svg";
import logoDesktop from "../../assets/logo/horizontal-large.svg";
import AppDownload from "../AppDownload/AppDownload";


interface IntroProps {
  translations: TranslationsMap
  showSponsor: boolean
}

const HeroPostLaunch : React.FC<IntroProps> = ({translations, showSponsor}) => {

  const sponsoredText = translations["landingPage.hero.sponsored"]

  return (
    <div className="hero-container">
      <div className="hero-content">
        <div>
          <img alt="Logo" className="display-mobile" src={logoMobile}/>
          <img alt="Logo" className="display-desktop" src={logoDesktop}/>
        </div>
        <div className="flex-grow"/>
        <div>
          <h1 className="mb-2">{translations["landingPage.hero.title"]}</h1>
          <p className="mb-6">{translations["landingPage.hero.body"]}</p>
          <AppDownload/>
        </div>
        <div className="display-desktop flex-grow"/>
        <div className="hero-bottom-container">
          {sponsoredText.length > 0 && showSponsor && (<p className="label-2 grey mt-4 sponsored-label">{sponsoredText}</p>)}
        </div>
      </div>
    </div>
  );
}

export default HeroPostLaunch;